import { render, staticRenderFns } from "./AfterSalePickList.vue?vue&type=template&id=08e1075b"
import script from "./AfterSalePickList.vue?vue&type=script&lang=js"
export * from "./AfterSalePickList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports